import React from 'react'
import classes from './Spinner.module.css'

export const Spinner = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <div className={classes.loader}>Loading...</div>
        </div>
        
    )
}
